/**
 * Trunnion AI - Execution API Endpoints
 */

import apiClient from './client';
import type {
  Execution,
  ExecutionListResponse,
  ExecutionFilters,
} from '@/types';

const BASE = '/executions';

export const executionsApi = {
  list: async (filters?: ExecutionFilters): Promise<ExecutionListResponse> => {
    const { data } = await apiClient.get(BASE, { params: filters });
    return data;
  },

  getById: async (id: string): Promise<Execution> => {
    const { data } = await apiClient.get(`${BASE}/${id}`);
    return data;
  },

  cancel: async (id: string, reason?: string): Promise<Execution> => {
    const { data } = await apiClient.post(`${BASE}/${id}/cancel`, { reason });
    return data;
  },

  pause: async (id: string): Promise<Execution> => {
    const { data } = await apiClient.post(`${BASE}/${id}/pause`);
    return data;
  },

  resume: async (id: string): Promise<Execution> => {
    const { data } = await apiClient.post(`${BASE}/${id}/resume`);
    return data;
  },

  approve: async (
    id: string,
    stepId: string,
    justification: string,
  ): Promise<Execution> => {
    const { data } = await apiClient.post(`${BASE}/${id}/steps/${stepId}/approve`, {
      justification,
    });
    return data;
  },

  deny: async (
    id: string,
    stepId: string,
    reason: string,
  ): Promise<Execution> => {
    const { data } = await apiClient.post(`${BASE}/${id}/steps/${stepId}/deny`, {
      reason,
    });
    return data;
  },

  retry: async (id: string): Promise<{ executionId: string }> => {
    const { data } = await apiClient.post(`${BASE}/${id}/retry`);
    return data;
  },
};
